export default __webpack_public_path__ + "static/media/ic_yapp_svg.c3013498.svg";